export default {
  tables_download: 'Télécharger',
  tables_delete: 'Supprimer',
  tables_view: 'Voir',
  tables_edit: 'Modifier',
  tables_impersonate: "Émulation d'utilisateur"
};
